import { render, staticRenderFns } from "./FormTwoA.vue?vue&type=template&id=bcb78aaa&scoped=true&"
import script from "./FormTwoA.vue?vue&type=script&lang=js&"
export * from "./FormTwoA.vue?vue&type=script&lang=js&"
import style0 from "./FormTwoA.vue?vue&type=style&index=0&id=bcb78aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb78aaa",
  null
  
)

export default component.exports